import script from "./SharedTextfield.vue?vue&type=script&setup=true&lang=ts"
export * from "./SharedTextfield.vue?vue&type=script&setup=true&lang=ts"

import "./SharedTextfield.vue?vue&type=style&index=0&id=8b079ac4&lang=postcss"

const __exports__ = script;

export default __exports__